if (!("fetch" in window)) {
  console.log("Fetch API not found, loading polyfill...");
  import("core-js/features/fetch");
}

if (!("closest" in Element.prototype)) {
  console.log("Element.prototype.closest not found, loading polyfill...");
  import("core-js/features/element/closest");
}

if (!("matches" in Element.prototype)) {
  console.log("Element.prototype.matches not found, loading polyfill...");
  import("core-js/features/element/matches");
}

if (!("remove" in Element.prototype)) {
  console.log("Element.prototype.remove not found, loading polyfill...");
  import("core-js/features/element/remove");
}

if (!("classList" in Element.prototype)) {
  console.log("Element.prototype.classList not found, loading polyfill...");
  import("core-js/features/dom-token-list");
}

if (!Array.prototype.includes) {
  console.log("Array.prototype.includes not found, loading polyfill...");
  import("core-js/features/array/includes");
}

if (!Array.prototype.fill) {
  console.log("Array.prototype.fill not found, loading polyfill...");
  import("core-js/features/array/fill");
}

if (!String.prototype.includes) {
  console.log("String.prototype.includes not found, loading polyfill...");
  import("core-js/features/string/includes");
}

if (!String.prototype.padStart) {
  console.log("String.prototype.padStart not found, loading polyfill...");
  import("core-js/features/string/pad-start");
}

if (!Object.assign) {
  console.log("Object.assign not found, loading polyfill...");
  import("core-js/features/object/assign");
}

if (typeof CustomEvent !== "function") {
  console.log("CustomEvent not found, loading polyfill...");
  import("core-js/features/custom-event");
}

if (!("Intl" in window)) {
  console.log("Intl not found, loading polyfill...");
  import("core-js/features/intl");
}

if (!("URL" in window)) {
  console.log("URL not found, loading polyfill...");
  import("core-js/features/url");
}

if (!("IntersectionObserver" in window)) {
  console.log("IntersectionObserver not found, loading polyfill...");
  import("core-js/features/intersection-observer");
}
